<script setup lang="ts">
import { ROLE_TYPE_LAWYER } from '@/shared/constants/roleTypeConstants';
import { useModalStore } from '@/shared/ui/AppModal/store/modal';

const isMobile: boolean = useIsMobile();

const modalStore = useModalStore();

const showAuthModal = () => {
  modalStore.setModalState('auth', true, {
    isLogin: false,
    mode: ROLE_TYPE_LAWYER,
  });
};
</script>

<template>
  <section :class="['lawyers-main', { _mobile: isMobile }]" data-testid="lawyers-main">
    <div class="lawyers-main__inner">
      <h1 class="lawyers-main__title">Получайте записи клиентов на юридические услуги</h1>
      <span class="lawyers-main__subtitle" data-testid="lawyers-main-subtitle">
        Принимайте клиентов, нуждающихся в юридической помощи, по записи
      </span>
      <div class="lawyers-main__button-wrapper" data-testid="lawyers-main-button-wrapper">
        <AppButton is-big button-text="Зарегистрироваться" @click="showAuthModal" />
      </div>
    </div>
  </section>
</template>

<style lang="less">
.lawyers-main {
  background: url('/images/lawyers-page/lawyers-main-bg.webp') center;
  background-size: cover;

  &__inner {
    .container-d();

    width: 100%;
    padding-top: 245px;
    padding-bottom: 204px;
  }

  &__title {
    .title-h1();

    color: #fff;
    max-width: 880px;
    margin-bottom: @size-x5;

    @media @tablet {
      font-size: 57px;
      line-height: 58px;
      max-width: 800px;
    }
  }

  &__subtitle {
    font-size: @size-x6;
    line-height: @size-x7;
    font-weight: 500;
    color: #fff;
    max-width: 840px;
  }

  &__button-wrapper {
    margin-top: 50px;
  }

  &._mobile &__inner {
    .container-m();

    padding-top: 133px;
    padding-bottom: 100px;
  }

  &._mobile &__title {
    font-size: @size-x6;
    line-height: 25px;
    text-align: center;
    margin-bottom: 6px;
  }

  &._mobile &__subtitle {
    display: flex;
    font-size: @size-x4;
    line-height: 22px;
    text-align: center;
  }

  &._mobile &__button-wrapper {
    text-align: center;
    margin-top: 116px;
  }
}
</style>
